// extracted by mini-css-extract-plugin
export default {"LastNumber":"Stripe_LastNumber__tctiI","Grid":"Stripe_Grid__rsLEs","Container":"Stripe_Container__fLKYZ","Centered":"Stripe_Centered__GRB+l"};